import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { Textarea } from '@/src/shadComponents/ui/textarea';

export default function TextAreaFieldType({ field }: { field: DocumentField }) {
    const [value, setValue] = useState<string>(field.value || '');
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue(field.name, value);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, setFieldValue]);

    return (
        <>
            <div className="mt-2">
                <Textarea
                    rows={5}
                    name={field.name}
                    id={`${field.name}-field`}
                    value={value}
                    placeholder={field.placeholder}
                    onChange={(e) => setValue(e.target.value)}
                />
            </div>
            {field.helperText ? (
                <p className="mt-3 text-sm leading-6 text-muted-foreground">
                    {field.helperText}
                </p>
            ) : null}
        </>
    );
}
